import { render, staticRenderFns } from "./AcceptForm.vue?vue&type=template&id=7b707366&scoped=true&"
import script from "./AcceptForm.vue?vue&type=script&lang=ts&"
export * from "./AcceptForm.vue?vue&type=script&lang=ts&"
import style0 from "./AcceptForm.vue?vue&type=style&index=0&id=7b707366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b707366",
  null
  
)

export default component.exports